import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useAlertLevelConfigs from '../../hooks/useAlertLevelConfig';

const HitSummary = ({ data, alertLevels }) => {
  const { getLevelLabel, getLevelColor } = useAlertLevelConfigs(alertLevels);

  return (
    <StyledContainer>
      <StyledDiv color={getLevelColor('High')}>
        <span /> {data?.High || 0} {getLevelLabel('High')}
      </StyledDiv>
      <StyledDiv color={getLevelColor('Good')}>
        <span /> {data?.Good || data?.Medium || 0} {getLevelLabel('Good')}
      </StyledDiv>
      <StyledDiv color={getLevelColor('Low')}>
        <span /> {data?.Low || 0} {getLevelLabel('Low')}
      </StyledDiv>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  width: 68px;
`;

const StyledDiv = styled.div`
  color: ${(props) => props.color};
  line-height: 14px;

  span {
    background-color: ${(props) => props.color};
    height: 7px;
    width: 7px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
  }
`;

HitSummary.propTypes = {
  data: PropTypes.object,
  alertLevels: PropTypes.array
};

const mapStateToProps = ({ amlsCommon }) => ({
  alertLevels: amlsCommon.alertLevelConfigs?.data
});

export default connect(mapStateToProps)(HitSummary);
